export enum LawPaySyncStatus {
  SYNCED = 'SYNCED',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  COMPENSATING = 'COMPENSATING',
  COMPENSATION_PENDING = 'COMPENSATION_PENDING',
  COMPENSATION_FAILED = 'COMPENSATION_FAILED'
}
